<template>
  <div class="pageView">
    <PageHeader/>
    <div class="mainContent">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import PageHeader from '../components/PageHeader'
export default {
  components: {
    PageHeader
  }
}
</script>
<style lang="less">
@import url('../style/index.less');
.pageView{
  height: 100%;
  .mainContent{
    background-color: @pageBgColor;
    overflow:hidden;
  }
}
</style>